// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/transact-premium/editor.scss
// module id = 5
// module chunks = 0